<script setup lang="ts">
import { type Component, compile, computed, markRaw } from 'vue'

import { type MessageKey, useI18n } from '@tix/language'

const { t } = useI18n()

interface Props {
  name: MessageKey
  components?: Record<string, Component>
}

const props = defineProps<Props>()

const PortalStringComponent = computed(() =>
  markRaw({
    components: props.components,
    render: compile(t(props.name)),
  }),
)
</script>

<template>
  <component :is="PortalStringComponent" />
</template>
